import React from 'react'
import styles from "./ActionButton.module.scss"
function ActionBtn({ statusName,onClick }) {
    const formattedStatusName = statusName?.toLowerCase().replace(/\s+/g, "-")
    return (
        <div onClick={onClick} className={` ${styles.actionBtn} ${styles[`actionBtn-${formattedStatusName}`]}`}>{statusName}</div>
    )
}

export default ActionBtn
